import { CertificationCreate } from '../request-models/certification-create.model';
import { CertificationUpdate } from '../request-models/certification-update.model';
import { omitUndefined } from './wire-value-utils';

/** The hub body for creating or renewing a certification: only the allowlisted fields that are set. */
export function toCertificationCreateRequest(fields: CertificationCreate): CertificationCreate {
  return omitUndefined<CertificationCreate>({
    certificationType: fields.certificationType,
    ownerType: fields.ownerType,
    organizationId: fields.organizationId,
    profileId: fields.profileId,
    certificateNumber: fields.certificateNumber,
    issuedDate: fields.issuedDate,
    expirationDate: fields.expirationDate,
    issuingAuthority: fields.issuingAuthority,
    state: fields.state,
    documentUrl: fields.documentUrl,
    documentFileName: fields.documentFileName,
    notes: fields.notes,
    previousCertificationId: fields.previousCertificationId,
  });
}

/**
 * The hub body for updating a certification. Copies only the allowlisted fields and drops the ones that are not
 * set, so an update stays partial; `null` (clear the field) is kept.
 */
export function toCertificationUpdateRequest(fields: CertificationUpdate): CertificationUpdate {
  return omitUndefined<CertificationUpdate>({
    certificateNumber: fields.certificateNumber,
    issuedDate: fields.issuedDate,
    expirationDate: fields.expirationDate,
    issuingAuthority: fields.issuingAuthority,
    state: fields.state,
    documentUrl: fields.documentUrl,
    documentFileName: fields.documentFileName,
    notes: fields.notes,
    status: fields.status,
  });
}
